module.exports = __webpack_public_path__ + "img/company-logo.fa5b65fa.png";